import { render, staticRenderFns } from "./AECBReportDetails.vue?vue&type=template&id=70b0856e"
import script from "./AECBReportDetails.vue?vue&type=script&lang=js"
export * from "./AECBReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports